export var getPrimaryColor = function () {
    var style = getComputedStyle(document.body);
    return style.getPropertyValue('--color-primary');
};
